import { formatMoney } from '@theme/utilities';

class FreeGifts extends HTMLElement {
  #abortController;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    // Listen for plan changes from plan-selector (bubbles up through the form)
    const form = this.closest('form[action$="/cart/add"]');
    const planSelector = form?.querySelector('plan-selector');

    if (planSelector) {
      planSelector.addEventListener('plan-selector:plan-changed', (e) => {
        this.#onPlanChanged(e.detail.planOption);
      }, { signal });
    }

    // Initialize: check current plan state
    const selectedCard = form?.querySelector('.plan-card--selected[data-plan-card]');
    if (selectedCard) {
      this.#onPlanChanged(selectedCard.getAttribute('data-plan-card'));
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
  }

  #onPlanChanged(selectedPlan) {
    const items = this.querySelectorAll('[data-gift-item]');
    items.forEach(item => {
      const minimumPlan = item.getAttribute('data-minimum-plan');
      if (!minimumPlan || selectedPlan.toLowerCase().includes(minimumPlan.toLowerCase()) || minimumPlan.toLowerCase().includes(selectedPlan.toLowerCase())) {
        item.classList.remove('free-gift-item--disabled');
      } else {
        item.classList.add('free-gift-item--disabled');
      }
    });
  }

  getActiveGiftItems() {
    const items = [];
    const giftElements = this.querySelectorAll('[data-gift-item]:not(.free-gift-item--disabled)');
    giftElements.forEach(el => {
      const variantId = el.getAttribute('data-variant-id');
      if (variantId) {
        items.push({ id: variantId, quantity: 1 });
      }
    });
    return items;
  }
}

if (!customElements.get('free-gifts')) {
  customElements.define('free-gifts', FreeGifts);
}
